// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3gYBF","resendInfoText":"OnGoingPaymentBox_resendInfoText__2Vj4c"};